import { Box, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function ReportTextPanel({ children, title }) {
  if (!children) return null;

  return (
    <Box sx={runSummaryAgentReportStyles.reportPanel}>
      <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Box>
  );
}
